import {getAssetPath} from "../../../../../../utils/get-asset-path.js";
import ProjectUtils from "../../../../../../utils/project-utils.js";
import AlarmTimelineService from "../../../../../../services/reports/alarm-timeline-service.js";

const iconPath = getAssetPath("img/alarm_time_line/");

const icons = {
    signing: `${iconPath}signing.png`,
    securityCam: `${iconPath}security-camera-white.png`,
    serverOk: `${iconPath}server-ok.png`,
    serverProcessing: `${iconPath}server-processing.png`,
    siren: `${iconPath}siren.png`,
    checked: `${iconPath}checked.png`,
}

function sortByDate(items) {
    return [...items].sort((a, b) => {
        const dateA = ProjectUtils.toDate(a.dt, "dd/MM/yyyy HH:mm:ss");
        const dateB = ProjectUtils.toDate(b.dt, "dd/MM/yyyy HH:mm:ss");

        if (!dateA) return 1;
        if (!dateB) return -1;

        return dateA - dateB;
    });
}

export function buildTimelineItems(data) {
    if (!data) return [];

    const items = [];
    const occurrences = ProjectUtils.safeJsonParse(data.occurrences, []);

    const sign1 = ProjectUtils.safeJsonParse(data.sign1, {});
    const sign2 = ProjectUtils.safeJsonParse(data.sign2, {});

    const assumeUserImage = data?.userassumeid ? AlarmTimelineService.getUserImage(data.userassumeid) : null;
    const sign1UserImage = sign1?.userSign ? AlarmTimelineService.getUserImage(sign1.userSign) : null;
    const sign2Userimage = sign2.userSign ? AlarmTimelineService.getUserImage(sign2.userSign) : null;

    occurrences.forEach((occ) => {
        if (occ?.dtCreate) {
            items.push({
                dt: occ.dtCreate,
                icon: icons.signing,
                text: (
                  <>
                    Cadastro de ocorrência (ID: {" "}
                      <span
                          className="cursor-pointer hover:text-[#1588F3]"
                          onClick={() => ProjectUtils.openOccurrence(occ.occid)}
                      >
                          {occ.occid}
                      </span>
                      )
                  </>
                ),
            });
        }
    });

    if (data.capture_time) {
        items.push({
            dt: data.capture_time,
            icon: icons.securityCam,
            text: "Imagem do veículo capturada pela câmera",
        });
    }

    if (data.datereceivedserver) {
        items.push({
            dt: data.datereceivedserver,
            icon: icons.serverOk,
            text: "Imagem recebida pelo servidor",
        });
    }

    if (data.dateocr) {
        items.push({
            dt: data.dateocr,
            icon: icons.serverProcessing,
            text: "OCR da imagem",
        });
    }

    if (data.dateocr2) {
        items.push({
            dt: data.dateocr2,
            icon: icons.serverProcessing,
            text: "Imagem reprocessada pelo servidor",
        });
    }

    if (data.datealarm) {
        items.push({
            dt: data.datealarm,
            icon: icons.siren,
            text: "Geração de alarme para o(s) agente(s)",
        });
    }

    if (data.eedt && data.eetype) {
        const dates = String(data.eedt).split(",");
        const types = String(data.eetype).split(",");

        dates.forEach((dt, index) => {
            items.push({
                dt,
                icon: icons.siren,
                text:
                    types[index] === "EXTERN-MJ"
                        ? "Recepção do alerta do Ministério da Justiça"
                        : "Recepção do alerta da SESP - PR",
            });
        });
    }

    if (data.datetimeassume) {
        const assume = ProjectUtils.safeJsonParse(data.assume, {});

        items.push({
            dt: data.datetimeassume,
            icon: icons.checked,
            text: `${data.userassume} assumiu o alarme${assume?.autoAssumed ? " automaticamente" : ""}`,
            image: assumeUserImage,
        });
    }

    if (data.datetimesign1) {
        const sign1 = ProjectUtils.safeJsonParse(data.sign1);

        items.push({
            dt: data.datetimesign1,
            icon: icons.signing,
            text: `${data.usersign1} assinou o alarme de 1ª fase`,
            questions: sign1?.questionsSign ?? [],
            image: sign1UserImage,
        });
    }

    if (data.datetimesign2) {
        const sign2 = ProjectUtils.safeJsonParse(data.sign2);

        items.push({
            dt: data.datetimesign2,
            icon: icons.signing,
            text: `${data.usersign2} assinou o alarme de 2ª fase`,
            questions: sign2?.questionsSign ?? [],
            image:sign2Userimage,
        });
    }

    if (data.mjInactivationSign?.dateTime) {
        items.push({
            dt: data.mjInactivationSign.dateTime,
            icon: icons.signing,
            text: data.mjInactivationSign?.message ?? "",
        });
    }

    occurrences.forEach((occ) => {
        if (occ?.dtClosed) {
            items.push({
                dt: occ.dtClosed,
                icon: icons.signing,
                text: `Encerramento da ocorrência (ID: ${occ.occid})`,
            });
        }
    });

    return sortByDate(items);
}